export default __webpack_public_path__ + "static/media/analytics.c98d2c41.jpg";